type PriorityCellRendererProps = {
  value: string;
};

export const PriorityCellRenderer = (props: PriorityCellRendererProps) => {
  const priority = props.value;

  // Define icon and color based on priority
  let icon = 'pi pi-minus';
  let color = '#6c757d'; // secondary/default color

  switch (priority) {
    case 'high':
      icon = 'pi pi-angle-up';
      color = '#ef4444'; // red for high priority
      break;
    case 'low':
      icon = 'pi pi-angle-down';
      color = '#3b82f6'; // blue for low priority
      break;
  }

  return (
    <div className="flex align-items-center justify-content-center flex-grow-1">
      <i className={icon} style={{ fontSize: '1rem', color: color }}></i>
    </div>
  );
};

export default PriorityCellRenderer;
